import { render, staticRenderFns } from "./SplitLine.vue?vue&type=template&id=7078a464&scoped=true&"
var script = {}
import style0 from "./SplitLine.vue?vue&type=style&index=0&id=7078a464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7078a464",
  null
  
)

export default component.exports